import { render } from "./AppAbout.vue?vue&type=template&id=f9485bf6"
import script from "./AppAbout.vue?vue&type=script&lang=js"
export * from "./AppAbout.vue?vue&type=script&lang=js"

import "./AppAbout.vue?vue&type=style&index=0&id=f9485bf6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__